<div class="form-field-wrapper">
  <label class="form-field-label" [ngClass]="{ 'required': isRequired }">
    <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
    {{ label }}
  </label>
  <div class="inline-options">
      <div class="form-check option" *ngFor="let option of options; let i = index">
        <input class="form-check-input" [formControl]="formControl" type="radio" [value]="option.value" [id]="'radio' + name + i" [name]="name">
        <label class="form-field-label" [for]="'radio' + name + i">
          {{ option.label | translate }}
        </label>
      </div>
  </div>
</div>
